// extracted by mini-css-extract-plugin
export var body = "OfferCard-module--body--d1c06";
export var cardContent = "OfferCard-module--card-content--dd19b";
export var disclaimer = "OfferCard-module--disclaimer--9e26c";
export var expiresOnChip = "OfferCard-module--expires-on-chip--48b8d";
export var icon = "OfferCard-module--icon--fc029";
export var iconUrl = "OfferCard-module--icon-url--0b4f7";
export var title = "OfferCard-module--title--23875";
export var titleContainer = "OfferCard-module--title-container--e7573";